export default __webpack_public_path__ + "static/floating-cogs-12d83ccb608a2d50965c7c9270fd8bfb.svg";